import { useState } from "react";
import historyImg16 from "../../images/patrimoine_history/16.jpg";
import historyImg17 from "../../images/patrimoine_history/17.jpg";
import historyImg18 from "../../images/patrimoine_history/18.jpg";
import historyImg19 from "../../images/patrimoine_history/19.jpg";
import historyImg20 from "../../images/patrimoine_history/20.jpg";
import historyImg21 from "../../images/patrimoine_history/21.jpg";
import historyImg22 from "../../images/patrimoine_history/22.jpg";
import historyImg23 from "../../images/patrimoine_history/23.jpg";
import historyImg24 from "../../images/patrimoine_history/24.jpg";
import Card from "../3DCarousel/Card";
import Carousel from "../3DCarousel/Carousel";

const PatrimoineHistory = () => {
  const [showMore, setShowMore] = useState(false);

  const toggleText = () => {
    setShowMore(!showMore);
  };

  const newsData = [
    {
      id: 2,
      title: "Après la mort de Louis XIV en 1715",
      desc: "la cour abandonne Versailles pour rejoindre Paris et les besoins en eau pour l’alimentation des fontaines du parc de Versaillesdiminuent",
    },
    {
      id: 3,
      title: "1737",
      desc: "la Machine de Marly alimente ainsi les fontaines de la Ville de Versailles.",
    },
    {
      id: 1,
      title: "1701",
      desc: "Enjeux sanitaire, alimenter la ville de Versailles en eau potable",
    },
    {
      id: 4,
      title: "1758",
      desc: "le comte de Noailles, en charge des affaires de la Ville demande que plus d’eau de Seine soit envoyée à Versailles.",
    },
    {
      id: 5,
      title: "Seconde moitié du 1801",
      desc: "Irriguer Saint-Cloud",
    },
    {
      id: 6,
      title: "1900 - 1901",
      desc: "Croissance urbaine et enjeu sanitaire",
    },
    {
      id: 7,
      title: "Milieu 1901",
      desc: "Croissance urbaine et enjeu sanitairePolitique de grands travaux de modernisation",
    },
    {
      id: 8,
      title: "Fin 1901 - Début 2001 ",
      desc: "Le réseau historique de l’eau dans le territoire du Grand Paris",
    },
    {
      id: 9,
      title: "A partir de 1980",
      desc: "le charbon actif en grains remplace les filtres à sable et une nouvelle usine de traitement est édifiée afin de répondre à l’accroissement des besoins en eau potable du territoire, en pleine expansion urbaine (création de la Ville Nouvelle de Saint-Quentin- en-Yvelines notamment).",
    },
    {
      id: 10,
      title: "1980",
      desc: "Construction de l’usine de traitement n°2",
    },
    {
      id: 11,
      title: "2015",
      desc: "Construction de l’usine de décarbonatation",
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  const cards =
    newsData &&
    newsData.map((item, index) => {
      return {
        key: item.id,
        content: (
          <Card
            key={item.id}
            title={item.title}
            desc={item.desc}
            shownBtn={false}
            bgColor={index === currentSlide ? "bg-primary" : "bg-gray"}
            textColor={index === currentSlide ? "text-white" : "text-black"}
            showAll={true}
            width="w-72 flex flex-col justify-between h-80"
            cardVersion="2"
            onClick={() => {
              setCurrentSlide(index);
            }}
          />
        ),
      };
    });
  return (
    <div className="container mx-auto mt-10 mb-20 md:px-40 sm:px-40">
      <div className="">
        <div id="siecle" className="">
          <p className="font-bold ">Les dates clés</p>
          <div className="flex justify-center ">
            <Carousel
              cards={cards}
              height="400px"
              width="80%"
              margin="0 auto"
              offset={2}
              showArrows={false}
              onSlideChange={setCurrentSlide}
              currentSlide={currentSlide}
            />
          </div>
        </div>
        <div className="mt-16">
          <div id="paragraphes mb-16">
            <p className="w-full text-justify">
              Le patrimoine hydraulique d’AQUAVESC témoigne de l’histoire de
              l’adduction d’eau à Versailles, depuis la création de la Machine
              de Marly jusqu&#39;aux ouvrages modernes, alliant ingénierie,
              architecture et paysage pour répondre aux besoins en eau de la
              ville.
            </p>
            <div className="mt-5">
              <p className="w-full text-justify">
                Le patrimoine d’AQUAVESC regroupe un ensemble unique
                d&#39;ouvrages historiques, techniques et paysagers, illustrant
                l’évolution du réseau d&#39;adduction d&#39;eau reliant la Seine
                à Versailles et ses environs depuis la fin du XVIIe siècle.
              </p>
              <p className="mt-4 text-justify">
                Ce patrimoine remonte à la volonté de Louis XIV de nourrir les
                fontaines de son parc à Versailles. Pour ce faire, la Machine de
                Marly a été construite, accompagnée de divers ouvrages tels que
                l’aqueduc de Louveciennes et le réservoir des Deux-Portes. En
                1678, le projet a été confié au gentilhomme Arnold de Ville et
                au maître charpentier liégeois Rennequin Sualem, qui ont conçu
                un dispositif hydraulique d’une ampleur inédite pour
                l&#39;époque, inspiré des machines utilisées pour l’exhaure des
                mines de Liège. La première Machine de Marly a été achevée en
                1684 et permettait de pomper l’eau de la Seine sur environ 150
                mètres de dénivelé.Pour transporter cette eau jusqu’au Château,
                plusieurs ouvrages ont été construits sur le plateau des Alluets
                et autour de Versailles, dont l’aqueduc de Louveciennes, le
                réservoir des Deux-Portes, le Regard du Jongleur, et les
                réservoirs de Montbauron.
              </p>
              <p className="text-justify">
                Au fil des siècles, ce réseau hydraulique a évolué pour répondre
                aux nouveaux besoins de la ville et de ses environs, tout en
                conservant sa fonction de captation et de distribution d’eau. Il
                a aussi su préserver ses caractéristiques architecturales et
                paysagères. Certains ouvrages sont protégés en tant que
                Monuments Historiques.
              </p>
            </div>
            <div className="mt-20 ">
              <div className="w-full">
                <div id="item-18">
                  <p className="font-bold text-black">
                    L’AMÉLIORATION DES FILTRAGES
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg16}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                    <p className="mt-2 text-justify">
                      Le mode de fi ltrage du début du XIXe siècle retenait les
                      impuretés de l’eau mais lui lais-sait ses mauvaises odeurs
                      et ne lui apportait aucun assainissement. Comme le
                      montrent les lettres administratives échangées, ce fi
                      ltrage s’avère très vite insuffi sant d’autant que, le
                      siècle avançant, l’eau de Seine s’in-fecte. Elle est
                      déclarée imbuvable en 1874. Pour répondre à ce problème
                      sanitaire et aux besoins croissants de la population, le
                      Pavillon des Filtres subit d’importants re-maniements à la
                      fi n du XIXe siècle. Les bacs de fi ltrage et les
                      diamètres des conduites sont agrandis. Les canalisations
                      passent du plomb à la fonte. Le fi ltrage s’effectue
                      dé-sormais par couches alternées de sable de rivière et de
                      charbon de bois. Enfi n, un sys-tème de nettoyage des
                      cuves par projection d’eau est adopté. <br />
                      Les bâtiments annexes adossés en 1899 au Pavillon des fi
                      ltres auront pour tâche d’alimenter le Haut Clagny et
                      d’augmen-ter la quantité d’eau fournie à la ville de
                      Versailles. En cet état et à quelques évolutions mineures
                      près, <br />
                      le Pavillon continuera à remplir ces fonctions jusqu’en
                      1963. Il est alors désaffecté et tombe en ruine. Clas-sé
                      monument historique en 1979, il sera restauré en 1997.
                    </p>
                  </p>
                </div>

                <div id="item-19">
                  <p className="mt-2 font-bold text-black">
                    L’ÉVOLUTION DE LA MACHINE DE MARLY I
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg17}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                    <p className="mt-2 text-justify">
                      La Machine construite par Arnold de Ville et Rennequin
                      Sualem fonctionnera 132 ans de 1685 à 1817. À partir de
                      1804, Brunet effec-tue des essais de montée en un seul jet
                      avec une seule roue. Ces essais se soldent par un échec
                      suite à l’explosion des tuyaux. En 1807, Bralle améliore
                      le principe de Brunet et obtient des résultats
                      satisfaisants avec cette machine dite de la 14e roue.{" "}
                      <br />À partir de 1811, il est décidé d’utiliser une
                      machine à vapeur. Pendant sa construc-tion, Cécile met au
                      point une pompe qui élève l’eau d’un seul jet grâce à un
                      système d’engrenages évitant les à-coups. En 1814, cette
                      machine d’essai délivre jusqu’à 400 m3 par jour. La
                      technique de Cécile est donc adoptée : deux roues à aubes
                      de l’ancienne Machine entraînant quatre pompes. Cette
                      Machine est complétée en 1827 par la machine à vapeur. En
                      1837, un rapport montre que, pour des raisons de coût (10
                      t de charbon/jour), il est préférable de revenir à la
                      force hydraulique avec des principes connus. En 1854,
                      Napoléon III décide la construction d’une nouvelle machine
                      hydraulique. La machine à vapeur fonctionne seule pendant
                      la construction de la machine de Dufrayer. Cette dernière
                      est composée de 6 roues motrices de 12 mètres de diamètre
                      à struc-ture de fer et pales de bois actionnant 24 pompes
                      horizontales qui refoulent l’eau de la Seine dans deux
                      conduites. La pression de l’eau était stabilisée par des
                      réservoirs à air comprimé évitant les coups de bélier. En
                      1869, la Machine élève 5 400 m3 d’eau par jour.
                    </p>
                  </p>
                </div>

                <div id="item-20">
                  <p className="mt-2 font-bold text-black">
                    L’ÉVOLUTION DE LA MACHINE DE MARLY II
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg18}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                    <p className="mt-2 text-justify">
                      Pour remplacer l’eau de Seine devenue imbuvable dès 1874,
                      un premier puits est foré en 1880 dans une cour de la
                      Machine de Marly. D’autres puits seront forés sur la rive
                      gauche de la Seine jusqu’en 1894. Ils ne suffi ront pas.
                      Entre 1894 et 1900, quatre nouveaux puits d’une profondeur
                      de 25 à 30 m sont forés sur la rive droite. Tous ces puits
                      fournissent 21 000 m3/jour, soit la capacité élévatoire de
                      la Machine de Marly.{" "}
                      {showMore && (
                        <>
                          <br />
                          Jusqu’à la fi n du XIXe siècle, des machines à vapeur
                          sont utilisées pour pomper l’eau des forages. A partir
                          de 1900, des moteurs élec-triques entraînés par des
                          turbines à vapeur sont installés sur les puits. <br />
                          Parallèlement, la machine de Dufrayer se transforme en
                          centrale hydroélectrique mue par les eaux de la Seine
                          tout en continuant d’élever l’eau jusqu’aux réservoirs
                          de Louveciennes et des Deux-Portes. Elle sera
                          simultanément secondée par une machine à vapeur pour
                          élever l’eau en cas de crue ou de gel. Au début des
                          années 30, la capacité élévatoire de la Machine de
                          Marly est augmentée par de nouveaux groupes
                          électriques et diesel. Dans le même temps, l’unique
                          canalisation reliant Marly à Louveciennes est doublée
                          par une seconde canalisation enterrée pa-rallèle à la
                          première. <br />
                          Arrêtée en 1963, la dernière Machine de Marly sera
                          démolie en 1968 à l’occasion du réaménagement du bras
                          de la Seine sur le-quel elle était édifi ée
                        </>
                      )}
                    </p>
                    <button
                      onClick={toggleText}
                      className="text-sm text-blue-500"
                    >
                      {showMore ? "voir moins" : "voir plus"}
                    </button>
                  </p>
                </div>

                <div id="item-21">
                  <p className="mt-2 font-bold text-black">
                    LES PREMIERS CAPTAGES SOUTERRAINS
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg19}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                    <p className="mt-2 text-justify">
                      Les premiers puits forés au début du siècle de part et
                      d’autre de la Seine donneront satisfaction pendant de
                      longues années. Prélevées à 25-30 m dans la craie
                      séno-nienne, les eaux des puits de Croissy étaient
                      cependant très calcaires et menacées de contamination.
                      Cette situation conduisit à chercher l’eau ailleurs pour
                      répondre aus- si à des nécessités démographiques et au
                      souci de l’hygiène publique.{" "}
                      {showMore && (
                        <>
                          {" "}
                          <br />
                          De 1929 à 1931, un puits artésien est amé-nagé dans la
                          cour de la Machine de Marly. L’eau jaillissante
                          provient d’une couche si-tuée à 503 m de profondeur ;
                          son débit est de 10 000 m3 par jour. Cette eau d’infi
                          ltration résulte des eaux de pluie tombant sur les
                          plaines de la Champagne et sur la région rouennaise.
                          Sortant de terre à 27 °C, l’eau est d’abord refroidie
                          avant d’être refoulée par les pompes de la Machine de
                          Marly. Stockée dans le réservoir de Louveciennes, elle
                          est ensuite distribuée à Versailles et aux communes
                          environnantes. <br />
                          En 1935, une nouvelle augmentation de la consommation
                          nécessite le forage de deux nouveaux puits dans la
                          plaine de Croissy. À cette époque, de nombreuses
                          autres amé-liorations seront réalisées : renforcement
                          de la canalisation entre Marly et Versailles,
                          construction du premier château d’eau de Satory (1 500
                          m3) et pose d’une conduite vers Saint-Cyr et Trappes.
                        </>
                      )}
                    </p>
                    <button
                      onClick={toggleText}
                      className="text-sm text-blue-500"
                    >
                      {showMore ? "voir moins" : "voir plus"}
                    </button>
                  </p>
                </div>

                <div id="item-22">
                  <p className="mt-2 font-bold text-black">
                    LES GRANDES EAUX DE VERSAILLES
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg20}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                  </p>
                </div>

                <div id="item-23">
                  <p className="mt-2 font-bold text-black">
                    LA PRODUCTION ET LE STOCKAGE DE L’EAU
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg21}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                  </p>
                </div>

                <div id="item-24">
                  <p className="mt-2 font-bold text-black">
                    L’ACHEMINEMENT DE L’EAU POTABLE POUR VERSAILLES ET SES
                    ENVIRONS
                  </p>
                  <p>
                    <div className="mt-5">
                      <img
                        src={historyImg22}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                    <p className="mt-2 text-justify">
                      À partir des années 50, de nombreuses ins-tallations sont
                      modernisées afi n d’assurer l’approvisionnement en eau en
                      quantité et qualité, et garantir la continuité et la
                      sécu-rité de la distribution d’eau potable.{" "}
                      {showMore && (
                        <>
                          {" "}
                          <br />
                          L’approvisionnement en eau est assuré grâce à onze
                          puits dans la nappe de Crois-sy, réalimentée par de
                          l’eau de Seine, d’une capacité de 5 000 m3/heure. Une
                          nouvelle traversée de la Seine est réalisée par la
                          pose d’un siphon de 900 mm en 1980. De nouvelles
                          pompes électriques sont mises en place sur l’usine
                          élévatoire de Bougival, aujourd’hui regroupées dans le
                          bâtiment Charles X et d’une capacité de 5000 m3/heure,
                          soit 40 fois plus que l’ancienne Machine de Marly.
                          <br />À Louveciennes deux réservoirs supplémen-taires
                          portent la capacité de l’eau brute à plus de 500 000
                          m3, afi n de faire face aux pointes élevées de
                          consommation journalière et de constituer une réserve
                          de sécurité en cas d’incident sur les conduites
                          ascendantes. Enfi n, la première usine de fi ltration
                          sur sable est réalisée entre 1955 et 1958 sur es
                          bassins de Louveciennes. En 1980, ces fi ltres sont
                          remplacés par du charbon actif en grains et une
                          nouvelle usine de traitement des eaux est construite,
                          afi n de faire face à l’accroissement des besoins en
                          eau d’un territoire en plein développement, avec
                          no-tamment la création de la Ville Nouvelle de
                          Saint-Quentin. L’usine de Louveciennes peut produire
                          aujourd’hui 120 000 m3 d’eau par jour, garantissant
                          ainsi les besoins de pointe de 350 000 habitants dont
                          85 700 à Versailles. Des traitements de haute
                          technicité, associant l’ozonation, la fi ltration sur
                          char-bon actif en grains et la chloration assurent
                          l’élimination particulièrement poussée des germes et
                          micropolluants organiques. Le contrôle centralisé
                          24h/24 surveille, com-mande et gère l’ensemble des
                          installations de production et de distribution sur le
                          terri-toire du SMGSEVESC (Syndicat Mixte pour la
                          Gestion du Service des Eaux de Versailles et
                          Saint-Cloud).
                        </>
                      )}
                    </p>
                    <button
                      onClick={toggleText}
                      className="text-sm text-blue-500"
                    >
                      {showMore ? "voir moins" : "voir plus"}
                    </button>
                  </p>
                </div>

                <div id="item-25">
                  <p className="mt-2 font-bold text-black">
                    LES SERVICES DE L’EAU AUJOURD’HUI
                  </p>
                  <p className="mt-2 text-justify">
                    EN 1980 LE SERVICE HISTORIQUE DES EAUX ET FONTAINES EST
                    SCINDÉ EN DEUX ENTITÉS <br /> LE SERVICE DES FONTAINES DE
                    VERSAILLES <br />
                    <div className="mt-5">
                      <img
                        src={historyImg23}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                    <p className="mt-2 text-justify">
                      Le Service des Fontaines du Château de Versailles gère les
                      fontaines des Parcs de Versailles, Trianon, Marly et
                      Saint-Cloud, en collectant et en utilisant de l’eau brute
                      (non potable). À travers les savoir-faire, la pra-tique
                      des techniques anciennes, mais aussi modernes, les
                      fontainiers du Château de Versailles s’attachent à
                      conserver et à faire fonctionner leurs fontaines comme à
                      l’époque de Louis XIV. <br /> Une "Supervision" per-met la
                      gestion des niveaux des réservoirs et l’ouverture des
                      fontaines de la Perspective.
                      <br />• 9 fontainiers œuvrent toute l’année pour que les
                      Grandes Eaux fonctionnent tous les week-ends entre avril
                      et octobre. <br /> • 90 spectacles par an : Grandes Eaux
                      Musicales, Grandes Eaux Nocturnes et Fêtes de Nuit. <br />{" "}
                      • Quantité : 3 500 m3/h d’eau brute consom-mée pour les
                      Grandes Eaux de Versailles. <br /> • 50 fontaines dans le
                      Petit Parc de Versailles, représentant 670 effets d’eau.{" "}
                      <br />• 35 km de canalisations en fonte et en plomb.{" "}
                      <br /> • 70 vannes à manœuvrer pendant les spectacles.
                    </p>
                  </p>
                </div>
                <div id="item-26">
                  <p className="mt-2 font-bold text-black">
                    LE SERVICE DE L’EAU (SEVESC)
                  </p>
                  <p className="mt-2 text-justify">
                    La Société des Eaux de Versailles et de Saint-Cloud (SEVESC)
                    exploite pour le compte du SMGSEVESC le service de
                    production et de distribution de l’eau potable. À travers le
                    savoir-faire et l’innovation de la SEVESC, les communes
                    bénéfi cient des meilleures tech-nologies : Optifl ux fait
                    appel à la modélisa-tion et l’instrumentation des ouvrages
                    et réseaux, pour une gestion en temps réel. Les équipes de
                    terrain sont équipées d’outils embarqués pour améliorer la
                    réactivité et l’effi cacité des interventions. <br />• 250
                    salariés et agents œuvrent chaque jour pour apporter aux
                    consommateurs un service de qualité, 24h/24. <br /> • Le
                    SMGSEVESC regroupe aujourd’hui 24 communes autour de
                    Versailles. <br /> • Quantité : 23,5 millions de m3 d’eau
                    distribués chaque année (dont 8,5 millions de m3 à
                    Versailles). <br /> • 63 paramètres de qualité sanitaire
                    contrôlés avant distribution. <br /> • 859 km de
                    canalisations d’eau potable. <br /> • 38 400 compteurs (dont
                    7400 à Versailles). <br /> <br />
                    Aujourd’hui, le Service des Fontaines innove pour le
                    développement durable de la gestion de l’eau brute et la
                    SEVESC pour la préservation des ressources en eau et de la
                    biodiversité locale. <br /> <br />
                    LE PATRIMOINE DES FONTAINES DE VERSAILLES
                    <div className="mt-5">
                      <img
                        src={historyImg24}
                        alt=""
                        className="w-full rounded-lg "
                      />
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatrimoineHistory;
